import {
  findQuestionnaire,
  getAnsweredQuestions,
  getQuestionnaireText,
  type QuestionnaireResponse,
} from "@/domain/questionnaire";
import { useI18n } from "@/i18n/useI18n";

/** Read-only summary of a private questionnaire response. */
export function ResponseSummary({ response }: { response: QuestionnaireResponse | null }) {
  const { t, language } = useI18n();
  const config =
    response && findQuestionnaire(response.questionnaire_id, response.questionnaire_version);
  if (response && !config)
    return <p className="auth-gate-message error">{t("formUnknownVersion")}</p>;
  const answered =
    config && response ? getAnsweredQuestions(config, response.answers ?? {}, language) : [];
  if (!config || !answered.length) return <p>{t("formNoResponse")}</p>;

  return (
    <div className="questionnaire-summary">
      <h3 className="form-section-title" title={`${config.id} v${config.version}`}>
        {getQuestionnaireText(config.heading, language)}
      </h3>
      {answered.map(({ question, fields }) => (
        <section
          key={question.number ?? getQuestionnaireText(question.title, "no")}
          className="questionnaire-question"
        >
          <h3 className="questionnaire-question-title">
            {question.number} {getQuestionnaireText(question.title, language)}
          </h3>
          {fields.map(({ field, display }) => (
            <div key={field.key} className="questionnaire-answer">
              <div className="questionnaire-answer-title">
                {getQuestionnaireText(field.label, language)}
              </div>
              {display}
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
